import { types, flow } from 'mobx-state-tree';
import { makeRequest, errorResponse, navigate } from 'js/services/Network';
import { pick } from 'lodash';

import TokenSummary from './TokenSummary';

export default types
  .model('TokenDashboard', {
    isLoading: false,
    error: types.maybeNull(types.string),
    tokens: types.array(TokenSummary),
    field: '',
    query: '',
    page: 1,
    last_page: 0,
    count: 10,
    total: 0,
  })
  .views(self => ({
    get hasMorePages() {
      return self.page < self.last_page;
    },
  }))
  .actions(self => ({
    load: flow(function* load() {
      let response;

      if (!self.isLoading) {
        self.isLoading = true;
        self.error = null;

        const urlParams = new URLSearchParams(window.location.search);
        let params = {};
        if (urlParams.get('f') && urlParams.get('q')) {
          params = {
            field: urlParams.get('f'),
            query: urlParams.get('q'),
          };
        }

        try {
          response = yield makeRequest('admin-tokens-dashboard-data', null, {
            ...params,
            ...pick(self, ['page', 'count']),
          });
          self.last_page = response.data.last_page;
          self.total = response.data.total;
          self.tokens = response.data.data;
        } catch (error) {
          self.error = errorResponse(error);
        }

        self.isLoading = false;
      }

      return response;
    }),
    setPage(page = 1) {
      page = parseInt(page || 1);
      if (page !== self.page) {
        self.page = page;
        self.load();
      }
    },
    setQueryParams({ field, query }) {
      if (self.field !== field || self.query !== query) {
        self.field = field;
        self.query = query;
        self.load();
      }
    },
    searchNow(event, { field, query }) {
      self.page = 0;
      if (query) {
        navigate(`/admin/tokens/1?f=${encodeURIComponent(field)}&q=${encodeURIComponent(query)}`);
      } else {
        navigate(`/admin/tokens/1`);
      }
    },
  }));
